import { deepMerge, getTargetOffsetTop } from 'js/utils/Utils'
import { lerp, clamp, roundEx } from 'js/utils/Maths'

import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'homeCareerCopyScrollProgressAnimation',
  $names: {
    copy: '[data-scroll-progress-anim="home-career-copy"]',
    copyLine: '[data-scroll-progress-anim="home-career-copy-line"]',
    copyLineInner: '[data-scroll-progress-anim="home-career-copy-line-inner"]',
  },
  effectInfo: {
    maskLerpFactor: 0.2,
  },
}

export default class HomeCareerCopyScrollProgressAnimation {
  $contentRoot = document
  $copies = []
  copyInfo = []
  wh = 0

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this.setInfo()
    this.setPositions()
    this._addHandlers()
  }

  destroy() {
    this._removeHandlers()
  }

  _set$() {
    this.$copies = this.$contentRoot.querySelectorAll(this.$names.copy)
  }

  setInfo() {
    this.$copies.forEach(($copy, i) => {
      const $copyLines = $copy.querySelectorAll(this.$names.copyLine)
      const $copyLineInners = $copy.querySelectorAll(this.$names.copyLineInner)

      this.copyInfo[i] = {
        $copy,
        $copyLines,
        $copyLineInners,
        start: 0,
        end: 0,
        progress: 0,
        maskProgress: 0,
      }
    })
  }

  _addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(() => {
        this.onRaf()
      }, this.instanceName)
    }

    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, this.instanceName)
    }
  }

  _removeHandlers() {
    if (Common.raf) {
      Common.raf.removeHandler(this.instanceName)
    }

    if (Common.resize) {
      Common.resize.removeHandler(this.instanceName)
    }
  }

  setPositions() {
    this.wh = window.innerHeight
    this.copyInfo.forEach((info) => {
      const rect = info.$copy.getBoundingClientRect()
      const offsetTop = getTargetOffsetTop(info.$copy)
      const contentHeight = rect.height

      info.start = offsetTop - this.wh
      info.end = info.start + this.wh * 0.5 - contentHeight / 2
    })
  }

  _setScrollEffects() {
    this.copyInfo.forEach((info) => {
      info.progress = (Common.scroll.currentScroll - info.start) / (info.end - info.start)
      info.progress = clamp(info.progress, 0, 1)
      info.maskProgress = lerp(info.maskProgress, info.progress, this.effectInfo.maskLerpFactor / Common.raf.fpsMultiplier)

      let translateXLine = roundEx((1 - info.maskProgress) * -100, 1000)
      let translateXLineInner = roundEx((1 - info.maskProgress) * 100, 1000)

      if (info.$copyLines[1]) info.$copyLines[1].style.transform = `translateX(${translateXLine}%)`
      if (info.$copyLineInners[1]) info.$copyLineInners[1].style.transform = `translateX(${translateXLineInner}%)`
    })
  }

  onResize() {
    this.setPositions()
  }

  onRaf() {
    this._setScrollEffects()
  }
}